import { StateService } from "@uirouter/angularjs";

export class HttpHandlerService {
    httpService:ng.IHttpService;
    handlerUrl:string;

    constructor(public $http: ng.IHttpService, public $q: ng.IQService, public $state: StateService) {
        this.httpService = $http;
    }

    useGetHandler(route:string, action:string, params:any):ng.IPromise< any > {
        var result:ng.IPromise< any > = this.httpService.get(this.getUrl(route, action), params)
            .then(
                (response:any):ng.IPromise< any > => {
                    return this.handlerResponded(response, params);
                },
                (error:angular.IHttpPromiseCallbackArg<any>)=>{
                    return this.$q.reject(this.handleErrorResponse(route,action, error));
                }
            );
        return result;
    }

    usePostHandler(route:string, action:string, params:any, config?:any):ng.IPromise< any > {
        var result:ng.IPromise< any > = this.httpService.post(this.getUrl(route, action), params, config)
            .then(
                (response:any):ng.IPromise< any > => {
                    return this.handlerResponded(response, params);
                },
                (error:angular.IHttpPromiseCallbackArg<any>)=>{
                    return this.$q.reject(this.handleErrorResponse(route,action, error));
                }
            );
        return result;
    }

    usePutHandler(route:string, action:string, params:any):ng.IPromise< any > {
        var result:ng.IPromise< any > = this.httpService.put(this.getUrl(route, action), params)
            .then(
                (response:any):ng.IPromise< any > => {
                    return this.handlerResponded(response, params);
                },
                (error:angular.IHttpPromiseCallbackArg<any>)=>{
                    return this.$q.reject(this.handleErrorResponse(route,action, error));
                }
            );
        return result;
    }

    useDeleteHandler(route:string, action:string, params:any):ng.IPromise< any > {
        var result:ng.IPromise< any > = this.httpService.delete(this.getUrl(route, action), params)
            .then(
                (response:any):ng.IPromise< any > => {
                    return this.handlerResponded(response, params);
                },
                (error:angular.IHttpPromiseCallbackArg<any>)=>{
                    return this.$q.reject(this.handleErrorResponse(route,action, error));
                }
            );
        return result;
    }

    handlerResponded(response:any, params?:any):any {
        //response.data.requestParams = params;
        if(response.status == 204)
            return null;
        else
            return response.data;
    }

    handleErrorResponse(route:string, action:string, error:angular.IHttpPromiseCallbackArg<any>):string{
        action = action.indexOf("?") > -1 ? action.substring(0, action.indexOf("?")) : action;
        var errMsg: string = "";
        if (error.data != null && error.data.message != null)
            errMsg = error.data.message;
        else if (error.data != null && error.data.Message != null)
            errMsg = error.data.Message;
        if (error.status == 403) {
            if (error.data != null && error.data.message != null && error.data.message.indexOf("License Exceeded") != -1) {
                this.$state.go('licenseexceeded');
            }
            else if (error.data != null && error.data.message != null)
                return error.data.message;
            else
                return "Your user account do not have enough privilege to take this action.";
        }
        if (error.status == 426) {
            this.$state.go('licenseexceeded');
        }
        if(error.status == 400)
            return errMsg;
        if (error.status == 401) {
            this.$state.go('loggedout');
        }
        if(errMsg.length == 0)
            return "Web service error at "+route+"/"+action+'-'+errMsg;
        else
            return errMsg;
    }

    protected getUrl(route:string, action:string){
        var url:string = process.env.assetWorxApiUrl + route + "/" + action;
        return url;
    }

    protected getBaseUrl():string{
        return "test"
    }

    protected getBasesUrl():string{
        return this.getBaseUrl() + "s";
    }

    protected formatStr(val:string):string{
        return val == null ? "" : val;
    }

} // HttpHandlerService class

export class ActionParams{
    action:string;
    params:any;
    constructor(action:string, params:any){
        this.action = action;
        this.params = params;
    }
}
